import KVMViewer from "modus/components/misc/KVMViewer";
import React from "react";
import { useSelector } from "react-redux";
import { IDENTITY_ENVIRONMENT_TYPE } from "header/environment-selector/ENV_CONSTANTS";
import { DeploymentStatusBadge, DeploymentStatusKeyType } from "./DeploymentStatusBadge";
import { EnvBadge } from "./EnvBadge";
import { DeploymentEditor } from "./DeploymentEditor";

interface DeploymentDetailsLegacyProps {
  region?: string;
  targetEndpoint?: string;
  deployedEndpoint?: string;
  timeout?: string;
  deploymentStatus?: string;
  deploymentId?: string;
  serviceId: string;
  refreshDeployments?: () => void;
}

/** KVM layout as on `develop` (Region/Environment, Target Endpoint, no API gateway row). */
export const DeploymentDetailsLegacy: React.FC<DeploymentDetailsLegacyProps> = (
  props
) => {
  const identityEnvironment = useSelector(
    (state: any) => state?.common?.identityEnvironment
  );

  return (
    <KVMViewer
      dataList={{
        [identityEnvironment === IDENTITY_ENVIRONMENT_TYPE.PRODUCTION
          ? "Region"
          : "Environment"]: <EnvBadge env={props?.region as any} />,
        "Target Endpoint": props?.targetEndpoint,
        "Deployed Endpoint": props?.deployedEndpoint,
        "Connection Timeout":
          props?.timeout === "1" ? "1 second" : `${props?.timeout} seconds`,
        "Deployment Status": (
          <DeploymentStatusBadge
            status={props?.deploymentStatus as DeploymentStatusKeyType}
          />
        ),
      }}
      controls={
        <DeploymentEditor
          updateDeployment={{
            isUpdate: true,
            serviceId: props?.serviceId,
            deploymentId: props?.deploymentId,
            targetEndpoint: props?.targetEndpoint,
            deployedEndpoint: props?.deployedEndpoint,
            timeout: parseInt(props?.timeout || "30"),
            region: props?.region,
            refreshDeployments: props.refreshDeployments,
            deploymentStatus: props?.deploymentStatus,
          }}
        />
      }
    />
  );
};
